import { render } from "./SetMoreUnNft.vue?vue&type=template&id=ddb417d8"
import script from "./SetMoreUnNft.vue?vue&type=script&lang=js"
export * from "./SetMoreUnNft.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__